import type { AiReviewSettingsErrorCode } from '@/lib/ai-review-settings/errors';

import { isAiReviewSettingsErrorCode } from '@/lib/ai-review-settings/errors';

export type ParsedAIReviewSettingsApiError = {
  code: AiReviewSettingsErrorCode | undefined;
  message: string | undefined;
};

/** Parses both the current structured error envelope and legacy string errors. */
export function parseAIReviewSettingsApiError(payload: unknown): ParsedAIReviewSettingsApiError {
  const serverError =
    typeof payload === 'object' && payload !== null && 'error' in payload
      ? (payload as { error?: unknown }).error
      : undefined;

  if (typeof serverError === 'string') {
    return { code: undefined, message: serverError };
  }

  if (typeof serverError !== 'object' || serverError === null) {
    return { code: undefined, message: undefined };
  }

  const code =
    'code' in serverError && isAiReviewSettingsErrorCode(serverError.code)
      ? serverError.code
      : undefined;
  const message =
    'message' in serverError && typeof serverError.message === 'string'
      ? serverError.message
      : undefined;

  return { code, message };
}
